export default "__VITE_ASSET__9cc7d001__"